"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _jsxruntime = require("react/jsx-runtime");
var _core = require("@mantine/core");
var _FormNotificationmodulecss = /*#__PURE__*/ _interop_require_default(require("../../../dist/assets/partnerTheme/FormNotification.module.css"));
var _clsx = /*#__PURE__*/ _interop_require_default(require("clsx"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var FormNotification = function(param) {
    var children = param.children, id = param.id, className = param.className, tmp = param["data-testid"], dataTestId = tmp === void 0 ? "form-notification" : tmp, ariaLive = param["aria-live"];
    return /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Box, {
        id: id,
        "data-testid": dataTestId,
        className: (0, _clsx.default)([
            _FormNotificationmodulecss.default.notification,
            className
        ]),
        "aria-live": ariaLive,
        children: /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Text, {
            children: children
        })
    });
};
var _default = FormNotification;
